"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getData = exports.isValidMask = exports.isValid = void 0;
const js_brasil_1 = require("js-brasil");
const axios_1 = __importDefault(require("axios"));
const webservice = 'https://api.cnpja.com.br/companies/#VAL#';
function isValid(value) {
    if (typeof value !== 'string' || /\D/.test(value))
        return false;
    return js_brasil_1.validateBr.cnpj(value.toString());
}
exports.isValid = isValid;
function isValidMask(value) {
    if (typeof value !== 'string')
        return false;
    return /\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}/.test(value);
}
exports.isValidMask = isValidMask;
async function getData(value) {
    if (value === undefined)
        return null;
    const cnpj = value
        .toString()
        .replace(/[^\d]+/g, '')
        .trim();
    const url = webservice.replace('#VAL#', cnpj);
    try {
        const response = await axios_1.default.get(url, {
            headers: {
                authorization: '71e212cf-d448-4c52-81ac-4aa5ad337fb2-b2b4804d-da48-442a-abf8-6dc708538ede',
            },
        });
        return response.data;
    }
    catch (error) {
        return null;
    }
}
exports.getData = getData;
//# sourceMappingURL=cnpj.js.map